module.exports = __webpack_public_path__ + "static/media/error.76758a29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/error.svg
// module id = 521
// module chunks = 0